'use client'

import { ReactNode, useEffect, useState } from 'react'

import { Footer } from '@/app/components/Footer'
import { Header, HEADER_HEIGHT } from '@/app/components/Header'

interface ErrorPageWrapperProps {
  children: ReactNode
}

/**
 * Client-side page wrapper for error pages.
 * Uses default theme (light header, no footer decoration) and fetches navigation client-side.
 */
export function ErrorPageWrapper({ children }: ErrorPageWrapperProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <>
      <Header
        mode="light"
        navGuest={null}
        navGuestCta={null}
        navAdvertiser={null}
        navPublisher={null}
      />
      <main className="flex flex-1 flex-col justify-top">
        <div style={{ paddingTop: HEADER_HEIGHT }}>{children}</div>
      </main>
      <Footer navigations={[]} />
    </>
  )
}
